import { FC } from "react";
import { HeaderPagesProps } from "./header-pages.types";

export const HeaderPages: FC<HeaderPagesProps> = ({ title, children }) => {
  return (
    <div className="lg:flex lg:items-center lg:justify-between pb-8">
      <div className="min-w-0 flex-1">
        <h2 className="text-sm font-bold leading-7 text-gray-900 sm:truncate sm:text-3xl sm:tracking-tight">
          {title}
        </h2>
      </div>
      <div className="mt-5 flex lg:ml-4 lg:mt-0">{children}</div>
    </div>
  );
};
